import { OrderFormat, OrderStatus } from "@ancon/wildcat-types";
import OrderStatusLabel from "../orderStatus/OrderStatusLabel";
import BodyText from "../support/BodyText";
import CloseIcon from "@ancon/wildcat-ui/shared/icons/close.svg";
import HeadingText from "../support/HeadingText";
import styles from "./OrderDetailsDrawer.module.scss";
import moment from "moment";
import OrderTypeIcon from "../support/OrderTypeIcon";
import Button from "../support/Button";

function OrderItem() {
  return (
    <div className={styles.itemContainer}>
      <div className={styles.itemContainerLeft}>
        <div className={styles.itemQuantityContainer}>
          <BodyText className={styles.itemQuantity}>2</BodyText>
        </div>
        <div className={styles.itemDetailsContainer}>
          <BodyText className={styles.itemName}>Product name</BodyText>
          <div>
            <>
              <BodyText color="body-2">Cheese</BodyText>
            </>
            <>
              <BodyText color="body-2">{`+ Egg`}</BodyText>
            </>
            <>
              <BodyText color="body-2">{`- Onions`}</BodyText>
            </>
          </div>
        </div>
      </div>
      <div className={styles.itemPriceContainer}>
        <BodyText className={styles.itemPrice}>100 kr</BodyText>
      </div>
    </div>
  );
}

export default function OrderDetailsDrawer() {
  return (
    <div className={styles.container}>
      <div className={styles.headerDetails}>
        <div>
          <div className={styles.topContainer}>
            <HeadingText as="h2">Order Summary</HeadingText>
          </div>
          <BodyText color="body-2">Outlet Name</BodyText>
          <div className={styles.orderStatusAndTime}>
            <div className={styles.actionWrap}>
              <OrderStatusLabel status={OrderStatus.NotRefunded} />
            </div>
            <BodyText className={styles.orderTime}>
              {moment().format("DD MMM YYYY [at] hh:mm A")}
            </BodyText>
          </div>
          <div className={styles.orderFormatRow}>
            <OrderTypeIcon orderFormat={OrderFormat.EatIn} />
            <BodyText as="span" className={styles.orderFormatText}>
              Eat In
            </BodyText>
          </div>
        </div>
        <Button variant="secondary">
          <CloseIcon />
        </Button>
      </div>
      <div className={styles.itemListContainer}>
        <OrderItem />
      </div>
      <div className={styles.footer}>
        <div className={styles.row}>
          <BodyText color="body-1">Delivery</BodyText>
          <BodyText color="body-1">10 kr</BodyText>
        </div>

        <div className={styles.row}>
          <BodyText color="body-1">Discount ( 5% OFF )</BodyText>
          <BodyText color="body-1">{`- 10kr`}</BodyText>
        </div>

        <div className={styles.footerContainer}>
          <div className={styles.footerLeft}>
            <div className={styles.totalItemCountWrapper}>
              <BodyText className={styles.totalItemCount}>2</BodyText>
            </div>
            <div className={styles.totalLabelWrapper}>
              <BodyText fontSize="1.6rem" className={styles.bold}>
                Total
              </BodyText>
              <BodyText color="body-1" className={styles.bold}>
                VAT Included
              </BodyText>
            </div>
          </div>
          <BodyText className={styles.totalPrice}>110 kr</BodyText>
        </div>
      </div>
    </div>
  );
}
